import React, { useContext, useCallback } from 'react';
import { IWatchContext, WatchContext } from '../watchState/watchContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';

export const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } = useContext<IWatchContext>(WatchContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmDeleteItem' && (
				<ModalToConfirm
					onConsentEvent={deleteSelectedItem}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="deleteWatch"
					typeOfInfoIcon="toDelete"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="deleteWatchSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorWhileDeletingWatch"
				/>
			)}
		</ModalWrapper>
	);
};
